import { h, Component } from 'preact'
import type { RedirectControlService } from './service'
import { E_RedirectType } from './types'
import './style.scss'

interface IRedirectControlProps {
    service: RedirectControlService
    debug?: boolean
}

export class RedirectControl extends Component<IRedirectControlProps> {
    state = {
        loading: false,
        redirectData: null,
        error: null,
    }

    componentWillMount() {
        const { service } = this.props
        this.setState({ loading: true })
        
        service.checkRedirectRequired()
            .then((redirectData) => {
                if (redirectData) {
                    this.setState({ redirectData })
                    this.handleRedirect(redirectData)
                }
            })
            .catch((error) => {
                this.setState({ error })
                console.error('Redirect control error:', error)
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    handleRedirect = (redirectData: any) => {
        const { service } = this.props
        
        switch (redirectData.type) {
        case E_RedirectType.MFA_AUTH:
            service.redirectToMFA(redirectData.mfaUrl)
            break
            // 后续可以添加更多跳转类型
        default:
            console.warn('Unknown redirect type:', redirectData.type)
        }
    }

    render() {
        const { debug } = this.props
        const { loading, error, redirectData } = this.state

        // 这个组件通常不需要渲染UI，因为它主要处理跳转逻辑
        // 在debug模式下可以显示一些状态信息
        if (debug && (loading || error || redirectData)) {
            return (
                <div className="redirect-control-debug">
                    <div className="title">重定向控制状态:</div>
                    {loading && <div className="status loading">检查中...</div>}
                    {error && <div className="status error">错误: {error.message}</div>}
                    {redirectData && <div className="status success">准备跳转: {redirectData.type}</div>}
                </div>
            )
        }

        return null
    }
} 